import React from 'react';
import './index.scss';

export interface IMask {
  children?: React.ReactChild;
  style?: React.CSSProperties;
  onClick?: () => void;
}

function Mask(props: IMask) {
  return (
    <div className="mask" style={props.style} onClick={props.onClick}>
      {props.children}
    </div>
  );
}
export default Mask;
